var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-holder"},[_c('span',{staticClass:"far loader fa-spinner fa-spin fa-3x"})])
}]

export { render, staticRenderFns }